import React from 'react'
import {
  LeftPanel,
  FeatureItem,
  FeatureName,
  AssignmentCount,
} from '../../screens/features.styled'

function FeatureList({features, selectedFeature, onSelect}) {
  if (features.length === 0) {
    return (
      <LeftPanel>
        <div
          style={{
            padding: '20px 16px',
            color: '#adb5bd',
            fontSize: '13px',
          }}
        >
          No features found.
        </div>
      </LeftPanel>
    )
  }

  return (
    <LeftPanel>
      {features.map(feature => {
        const isSelected = selectedFeature?.featureDesc === feature.featureDesc
        return (
          <FeatureItem
            key={feature.featureDesc}
            isSelected={isSelected}
            onClick={() => onSelect(feature)}
          >
            <FeatureName isSelected={isSelected}>
              {feature.featureDesc}
            </FeatureName>
            <AssignmentCount>{feature.assignments.length}</AssignmentCount>
          </FeatureItem>
        )
      })}
    </LeftPanel>
  )
}

export {FeatureList}
